import React, { Component } from 'react';
import { history } from '../../redux/store';
import { useEffect, useState } from 'react';
import moment from 'moment';
import axios from "axios";
import { Spin, Row, Col, Divider } from 'antd';
import { Button, Form, Input, Switch, Space } from 'antd';
import { LoginOutlined } from '@ant-design/icons/lib';
import setting from '../../config/setting';
import PublicLayout from '../../layout/public/Public';
import { useForm } from 'antd/es/form/Form';
import { navigateHome } from '../../utils/naviagate-home';
import { navigateEmployeeHome } from '../../utils/navigate-employee-home';
import metlogo from '../../assets/img/METLIFEWHT.png';
import msclogo from '../../assets/img/msclogo.png';
import covidBack from '../../assets/img/covid_background.png';
import { LoadingOutlined } from '@ant-design/icons';



import { useLocation,useParams } from "react-router-dom";

const { Item } = Form;



const SignIn = (props) => {

  const [name, setName] = useState('');
  const [otp, setOtp] = useState('');
  const [isEmail,setIsEmail]=useState('');
  const [logoType, setLogoType]=useState('metlife');
  const [spin,setSpin]=useState(false);
  const [show,setShow]=useState(false);


  const token = useParams();

  useEffect(() => {
    console.log("token params::",token);
    if(token){
      setLogoType(token['logoType']);
      localStorage.setItem("logoType", token['logoType']);
    }

  }, []);

  // console.log("propsData :: ", propsData);

  function userName(event) {
    console.log("event name", event.target.value);
    setName(event.target.value.trim());
  }

  // function password(event) {
  //   console.log("event pass", event.target.value);
  //   setPass(event.target.value);
  // }



  const [form] = useForm();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;



  function login() {
   setShow(false);
    // console.log(name);
    setName(name);
    // if(show===false){
    // setSpin(false);}
    // else{

    //   setSpin(true);
    //  // setShow(false);
    // }
    //console.log(name);
    let result=/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(name) || /^\d{12}$/.test(name);
    let emailTest = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(name);

    console.log("result :: ", result);
    if(result){
      setShow(false);
      setSpin(true);

      if (emailTest) {
        // call email api
        console.log("Verifying  email");
        axios.post(setting.serverUrl + '/EmployeeLoginWithOTP', {
          params: { email: name,
                    Mobile:name,
                    isEmail:isEmail
                  }
        }).then(response => {
          console.log("Response from login users", response)
          if (response && response.status == 200) {
              setSpin(false);
              setShow(false);
            console.log("connected user", response.data)
            // localStorage.setItem('employeeInfo', JSON.stringify(response.data));
            if(response.data && response.data.error){
              setShow(true);
              setSpin(false);
              // alert("User Not Found. Please enter valid usermail!");
            }else{

              history.push({pathname:'/public/EnterOtp', state: { email:name, id:response.data.id}});
            }
            // form
            // .validateFields()
            // .then(() => navigateHome())
            // .catch(() => null);

          } else {

            if (name === "" ) {
              setShow(true);
              setSpin(false);
              console.log("Not connected user");
            }
            else {
              setShow(true);
              setSpin(false);
            }
          }
        })

      } else {
        //  phone number api
        console.log(" Verifying phone number");

              }

        //Send otp as props to next page
        // history.push("/public/Enter-Otp");
    }
    else{
      // history.push("/public/EmployeeSign-in");
      // alert("Please enter valid Email/Phone Number")
      setShow(true);
      setSpin(false);
    }
  }



  return (

    <Row style={{
      height:'100%',
      backgroundImage: `url(${"covid_background.png"})`,
      backgroundSize: 'cover', backgroundPosition: '57% 50%', position: 'relative'
    }}>
      <Col span={7} style={{ height: '100%' }}>
        <div>

          <PublicLayout
          // bgImg={require('./wss.png')}
          >
            <h4 className='mt-0 mb-1'>Login</h4>

            <p
              style={{ color: '#161717' }}
            //className='text-color-200'
            >Login to access your Employee Account</p>

            <Form form={form} layout='vertical' className='mb-4'>
              <Item name='login' rules={[{ required: true, message: <></> }]}>
                <Input placeholder='Email/Phone Number' onChange={userName} />
              </Item>
{show?<div style={{color:"red"}}>*Please Enter Registered Email</div>:""}
              {/* <Item name='password' rules={[{ required: true, message: <></> }]}>
                <Input placeholder='Password' type='password' onChange={password}
                />
              </Item>

              <div className='d-flex align-items-center mb-4'>
                <Switch defaultChecked /> <span className='ml-2'>Remember me</span>
              </div> */}
{spin? <div><Spin indicator={antIcon} /> <span style={{color:"white",padding:5}}>Loading......</span></div>  :""}

                 {/* <Space size="middle" >
    <Spin size="small" />
  </Space>  */}
<br></br>
  <br></br>

              <Button
                block={false}
                type='primary'
                onClick={login}
                htmlType='submit'
                icon={<LoginOutlined style={{ fontSize: '1.3rem' }} />}
              >


                Login
        </Button>
            </Form>
            <br />
            {/* <p className='mb-1'>
              <a href='#'>Forgot password?</a>
            </p>

            <p>
              Don't have an account? <Link to='sign-up'>Sign up!</Link>
            </p> */}
          </PublicLayout>
        </div>
      </Col>
      <Col span={17}


      //style={{}}
      >
        {
          logoType && logoType === 'metlife'?
          <h3 style={{ textAlign: 'center', color: 'white', position: 'absolute', top: '20%', left: '30%' }}> <img src={metlogo} className='logo-img' /></h3>
          :
          logoType && logoType === 'msc'?
          <h3 style={{ textAlign: 'center', color: 'white', position: 'absolute', top: '15%', left: '30%' }}> <img src={msclogo}  style={{width:200}} /></h3>
          :null
        }
        <h3 style={{ textAlign: 'center', color: 'white', position: 'absolute', top: '40%', left: '15%' }}>WELCOME TO COVID-19 COMPLIANCE PORTAL</h3>
        {/* <img src={require('./wss.png')} style={{width:'100%',height:'fit-content'}} /> */}

      </Col>
    </Row>
  );
  // }
};

export default SignIn;
